import { mapGetters, mapActions } from 'vuex'

// Mixin providing dump in store methods
export default {
  name: 'DataTableDumpUserActionMixin',

  computed: {
    ...mapGetters({
      'applicationId': 'contextStore/applicationId',
      'workspaceId': 'contextStore/workspaceId',
      'contextTabId': 'contextStore/tabId',
      'trackerTypeId': 'contextStore/trackerTypeId',
      userActivities: 'userActivityStore/userActivities'
    }),

    dumpRoute () {
      return `/api/${this.applicationId}/workspace/${this.workspaceId}/${this.contextTabId}/${this.trackerTypeId}`
    }
  },

  methods: {
    ...mapActions({
      'persistUserAction': 'userActivityStore/persistUserAction'
    }),

    dumpUserAction (delta) {
      const route = this.dumpRoute
      this.persistUserAction({ route, delta })
    }
  }
}
